import { Button, Typography } from '@mui/material';
import { useNavigate } from 'react-router';
import waiting from '@/assets/images/svg/waiting.svg';
import { ContentBox } from '@/components/shared/content-box';

export const PaymentStatusStep = () => {
  const navigate = useNavigate();

  return (
    <ContentBox spacing={3} justifyContent="center" alignItems="center">
      <img src={waiting} alt="waiting" width={56} height={56} />
      <Typography variant="h2" textAlign="center">
        Aguardando confirmação
      </Typography>
      <Typography textAlign="center">
        Estamos confirmando o seu pagamento, mas não se preocupe! Quando
        confirmarmos, você receberá um e-mail com os próximos passos.
      </Typography>
      <Button variant="contained" onClick={() => navigate('/')}>
        Voltar para o início
      </Button>
    </ContentBox>
  );
};
